import * as pt from "@cicada-lang/partech";
import {} from "../../exp/BlockStmt.js";
import * as matchers from "../matchers/index.js";
export function block_stmt_matcher(tree) {
    return pt.matcher({
        "block_stmt:let": ({ names, exp }, { span }) => ({
            "@type": "BlockStmt",
            "@kind": "Let",
            names: matchers.variable_names_matcher(names),
            exp: matchers.exp_matcher(exp),
            span,
        }),
        "block_stmt:evaluate": ({ exp }, { span }) => ({
            "@type": "BlockStmt",
            "@kind": "Evaluate",
            exp: matchers.exp_matcher(exp),
            span,
        }),
        "block_stmt:return": ({ exp }, { span }) => ({
            "@type": "BlockStmt",
            "@kind": "Return",
            exp: matchers.exp_matcher(exp),
            span,
        }),
    })(tree);
}
export function block_stmts_matcher(tree) {
    return pt.matcher({
        "block_stmts:block_stmts": ({ entries }) => pt.matchers.zero_or_more_matcher(entries).map(block_stmt_matcher),
    })(tree);
}
//# sourceMappingURL=block_stmt_matcher.js.map